import React from 'react';
import PropTypes from 'prop-types';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import GoogleTagManager from '../components/analytics';
import ScrollToTop from '../components/scrolltotop';

const Main = (props) => (
  <HelmetProvider>
    <GoogleTagManager />
    <ScrollToTop />
    <Helmet titleTemplate="%s | Vista" defaultTitle="Vista" defer={false}>
      {props.title && <title>{props.title}</title>}
      <meta name="description" content={props.description} />
      <meta name='keyword' content='vista,vistaai,vistai,ai,digitalai' />    
    </Helmet>
    <div id="wrapper">
      <div id="main">
        {props.children}
      </div>
    </div>
  </HelmetProvider>
);


Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullPage: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
};

Main.defaultProps = {
  children: null,
  fullPage: false,
  title: null,
  description: "Vista | Advanced Artificial Intelligence",
};

export default Main;
